import React, { useEffect, useState } from "react";

export const PaginationBootstrap = (props) => {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    if (props.pageInfo?.totalPages) {
      const maxPages = Math.min(10, props.pageInfo.totalPages);
      const initialPages = Array.from({ length: maxPages }, (_, i) => i + 1);
      setPages(initialPages);
    }
  }, [props.pageInfo?.totalPages]);

  const getPageClass = (page) => {
    const baseClass = "page-link border-0 shadow-sm mx-1 rounded-3 fw-bold";
    const isActive = page === props.pageInfo.currentPage + 1;
    return isActive
      ? `${baseClass} bg-primary text-white`
      : `${baseClass} bg-white text-muted hover-pagination`;
  };

  const moveWindow = (direction) => (e) => {
    e.preventDefault();
    const updatedPages = [...pages];
    if (direction === 'prev' && updatedPages[0] > 1) {
      const firstPage = updatedPages[0] - 1;
      setPages([firstPage, ...updatedPages.slice(0, -1)]);
    } else if (direction === 'next' && updatedPages[updatedPages.length - 1] < props.pageInfo.totalPages) {
      const lastPage = updatedPages[updatedPages.length - 1] + 1;
      setPages([...updatedPages.slice(1), lastPage]);
    }
  };

  return (
    <div className="d-flex flex-column flex-md-row mt-4 justify-content-between align-items-center bg-light p-3 rounded-4 shadow-sm border gap-3">

      {/* SEÇÃO SUPERIOR (Mobile) / ESQUERDA (Desktop): Select e Texto */}
      <div className="d-flex align-items-center justify-content-center">
         <div className="text-muted small mx-3">
            Mostrando <strong>{props.pageInfo.totalElements}</strong> registros encontrados
        </div>

        <div className="me-2 d-none">
          <select
            className="form-select form-select-sm border-0 shadow-sm fw-bold text-muted rounded-3"
            style={{ width: '75px', cursor: 'pointer' }}
            value={props.pageInfo.size}
            onChange={(e) => props.changePageSize(Number(e.target.value))}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
             <option value="100">100</option>
              <option value="200">200</option>
          </select>
        </div>
       
      </div>

      {/* SEÇÃO INFERIOR (Mobile) / DIREITA (Desktop): Números */}
      <nav aria-label="Navegação">
        <ul className="pagination mb-0 flex-wrap justify-content-center gap-1">
          {/* Botão Anterior */}
          <li className={`page-item ${pages[0] <= 1 ? 'disabled opacity-50' : ''}`}>
            <a className="page-link border-0 rounded-3 bg-white shadow-sm p-2 px-3"
              href="#" onClick={moveWindow('prev')}>
              <i className="fas fa-chevron-left text-primary"></i>
            </a>
          </li>

          {/* Números das Páginas - No mobile, vamos reduzir o padding para caber mais */}
          {pages.map((page) => (
            <li key={page} className="page-item" style={{ cursor: 'pointer' }}>
              <a className={getPageClass(page)}
                style={{ padding: '8px 12px', minWidth: '40px', textAlign: 'center' }}
                onClick={() => props.goToPage(page - 1)}>
                {page}
              </a>
            </li>
          ))}

          {/* Botão Próximo */}
          <li className={`page-item ${pages[pages.length - 1] >= props.pageInfo.totalPages ? 'disabled opacity-50' : ''}`}>
            <a className="page-link border-0 rounded-3 bg-white shadow-sm p-2 px-3"
              href="#" onClick={moveWindow('next')}>
              <i className="fas fa-chevron-right text-primary"></i>
            </a>
          </li>
        </ul>
      </nav>
      <style>{`
        .hover-pagination:hover {
          background-color: #dee2e6 !important;
          color: #0d6efd !important;
          transition: 0.3s;
        }
        .page-link { padding: 8px 14px; }
        .form-select:focus { border-color: #0d6efd; box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.1); }
      `}</style>
    </div>
  );
};

export default PaginationBootstrap;